/**
 * Created by baladewa on 5/20/16.
 */
'use strict';
(function () {
    angular
        .module('commons')
        .component('managePairingComponentBk', {
            templateUrl: 'manage-pairing/components/manage-pairing-component-bk.tpl.html',
            controller: function (EventManagerService, ContextMenuService) {
                var vm = this, min_screen_width=1200, selectedBlockForContextMenu;
                vm.isElasticLoadingVisible = false;
                vm.model = {
                    pairingData :[],
                    filteredData:[]
                };
                vm.timeLineData = [];
                vm.groupLineData = [];
                vm.screen_left_panel = 0;
                vm.actual_screen_width = window.innerWidth;

                if (!!vm.actual_screen_width && vm.actual_screen_width > min_screen_width) {
                    vm.screen_right_panel = vm.actual_screen_width - vm.screen_left_panel;
                }

                vm.$onChanges = function (changeObj) {
                    if (changeObj.viewMode && changeObj.viewMode.currentValue && (changeObj.viewMode.currentValue != changeObj.viewMode.previousValue) ||
                        changeObj.fromDate && changeObj.fromDate.currentValue && (changeObj.fromDate.currentValue != changeObj.fromDate.previousValue) ||
                        changeObj.toDate && changeObj.toDate.currentValue && (changeObj.toDate.currentValue != changeObj.toDate.previousValue)) {
                        renderTimeLine();
                    }
                };

                vm.clickOnBlock = function(event, pair){
                    var option = {
                        event:event, selectedPair:pair
                    };
                    vm.selectAPair(option);
                    event.stopPropagation();
                };

                vm.dblOnBlock = function(event, pair){
                    var option = {
                        event:event, selectedPair:pair
                    };
                    vm.dblClickAPair(option);
                };

                vm.clickOnRow = function(event, pair){
                    var option = {
                        event:event, selectedPair:pair
                    };
                    vm.selectAPair(option);
                };

                vm.getPatternMenu = function(type, block){
                    selectedBlockForContextMenu = block;
                    return ContextMenuService.getContextMenu(type);
                };

                EventManagerService.registerEventListener(EventManagerService.EVENT.MANAGE_PAIRING.DATA_CHANGE, searchPairings);
                EventManagerService.registerEventListener(EventManagerService.EVENT.MANAGE_PAIRING.APPEND_PAIRING_DATA, searchPairings);
                EventManagerService.registerEventListener(EventManagerService.EVENT.MANAGE_PAIRING.UPDATE_PAIRING_DATA, updatePairings);

                function searchPairings(pairedData){
                    if(pairedData.length!==0){
                        vm.model.pairingData = pairedData;
                        filterData();
                    }
                }

                function updatePairings(dataToUpdate){
                    var selectedRow;
                    angular.forEach(dataToUpdate, function(pairing){
                        selectedRow = vm.model.filteredData[pairing.groupIndex].groupItems;
                        for (var i=0;i<selectedRow.length;i++){
                            var pairingInRow = selectedRow[i];
                            if(pairing.patternId === pairingInRow.patternId){
                                selectedRow.splice(i,1);
                                break;
                            }
                        }
                    })
                }

                function filterData(){
                    vm.model.filteredData = [];
                    vm.model.filteredData = _.each(vm.model.pairingData,function(obj){
                        return setPatternMeasurements(obj);
                    });
                }


                function setPatternMeasurements(patternGroup) {
                    angular.forEach(patternGroup.groupItems, function(pattern){
                        var tmpPatternEndInPx;
                        var mo_pattern_start = moment(vm.fromDate + ' ' + '00:00', 'DD/MM/YYYY HH:mm');
                        pattern.leftPos = getTimeInMinFromStartDate(pattern.startDate, pattern.startTime, mo_pattern_start);
                        tmpPatternEndInPx = getTimeInMinFromStartDate(pattern.endDate, pattern.endTime, mo_pattern_start);
                        pattern.widthInPx = (tmpPatternEndInPx - pattern.leftPos);
                        pattern.blockList = _.each(pattern.blockList, function(block){
                            var tmpBlockEndTimeInPx;
                            var mo_block_start = moment(pattern.startDate + ' ' + pattern.startTime, 'DD/MM/YYYY HH:mm');
                            block.leftPos = getTimeInMinFromStartDate(block.blockStartDate, block.blockStartTime, mo_block_start);
                            tmpBlockEndTimeInPx = getTimeInMinFromStartDate(block.blockDetailEndDate, block.blockDetailEndTime, mo_block_start);
                            block.widthInPx = (tmpBlockEndTimeInPx - block.leftPos);
                            block.blockDetailList = _.each(block.blockDetailList, function(blockDetail){
                                var tmpBlockDetailEndTimeInPx;
                                var mo_block_detail_start = moment(block.blockStartDate + ' ' + block.blockStartTime, 'DD/MM/YYYY HH:mm');
                                blockDetail.leftPos = getTimeInMinFromStartDate(blockDetail.departureDate, blockDetail.departureTime, mo_block_detail_start);
                                tmpBlockDetailEndTimeInPx = getTimeInMinFromStartDate(blockDetail.arrivalDate, blockDetail.arrivalTime, mo_block_detail_start);
                                blockDetail.widthInPx = (tmpBlockDetailEndTimeInPx - blockDetail.leftPos);
                            })
                        });
                    });
                    return patternGroup;
                }

                function getTimeInMinFromStartDate(checkInDate, checkInTime, relativeTo) {
                    var mo_checkIn = moment(checkInDate + ' ' + checkInTime, 'DD/MM/YYYY HH:mm');
                    var diffFromStart = mo_checkIn.diff(relativeTo, 'm');
                    return Math.round(diffFromStart * vm.minuteToPixelRatio);
                }

                function getNumberOfColsByStartEnd(start, end, byFlg, min){
                    var temp = end.diff(start, byFlg);
                    if (temp<min){
                        temp = min
                    }
                    return temp;
                }

                function renderTimeLine(){
                    var columnCount = 0,displayFormat = "";
                    vm.timeLineData = [];
                    vm.groupLineData = [];
                    vm.mo_start = col_start;
                    vm.scrollAreaWidth = 0;
                    vm.actual_number_of_coulmns = 0;
                    var col_start = moment(vm.fromDate, vm.dateFormat),
                        col_end = moment(vm.toDate, vm.dateFormat);

                    var columnGapBy = 'd', mincols=0;
                    if (vm.viewMode == 'D') {
                        columnGapBy = 'h';
                        displayFormat = "HH:mm";
                        mincols=24;
                        columnCount = 24;
                    }
                    if (vm.viewMode == 'W'){
                        displayFormat = "ddd";
                        mincols=7;
                        columnCount = 7;
                    }
                    if (vm.viewMode == '2W'){
                        displayFormat = "ddd";
                        mincols=7;
                        columnCount = 7;
                    }
                    if (vm.viewMode == 'M'){
                        displayFormat = "ddd";
                        mincols=7;
                        columnCount = 7;
                    }

                    vm.actual_number_of_coulmns = getNumberOfColsByStartEnd(col_start, col_end, columnGapBy, mincols);
                    vm.toDate = col_end.format(vm.dateFormat);
                    vm.columnWidthInPx = Math.floor((vm.screen_right_panel ) / mincols);
                    vm.minuteToPixelRatio = vm.columnWidthInPx / (60 * (vm.viewMode==='D'?1:24));

                    var tmp;
                    for (var i = 0; i < vm.actual_number_of_coulmns; i++) {
                        col_start = moment(col_start).startOf('day');
                        tmp = moment(col_start).add(i, columnGapBy);
                        vm.timeLineData.push({
                            headerLabel:tmp.format(displayFormat),
                            dayOfWeekShort: tmp.format('DDD'),
                            date: tmp.format('DD/MM/YYYY'),
                            dateShort : vm.viewMode == 'D'?'':tmp.format('DD/MM'),
                            leftPos: vm.columnWidthInPx * i
                        });
                        vm.scrollAreaWidth += vm.columnWidthInPx;


                        if( i % columnCount === 0 ){
                            vm.groupLineData.push({
                                dayLabelWidth: vm.columnWidthInPx * columnCount,
                                dayLabel: tmp.format('DD/MM/YYYY'),
                                dayOfWeekShort: tmp.format('ddd')
                            });
                        }
                    }
                    vm.scrollAreaWidth += 20;
                    if(vm.model.pairingData.length!==0){
                        EventManagerService.notifyEventListeners(EventManagerService.EVENT.MANAGE_PAIRING.DATA_CHANGE, vm.model.pairingData);
                    }
                }
            },
            bindings: {
                fromDate: '<',
                toDate: '<',
                viewMode: '<',
                dateFormat: '@',
                selectAPair: '&',
                dblClickAPair: '&'
            }
        })
})();